import { Pagination } from "antd";
import React from "react";

export const MyPagination = ({
  totalItems = 1,
  currentPage = 1,
  limit = 10,
  isLoading = false,
  showSizeChanger = false,
  changePage,
}) => {
  const onShowSizeChange = (currentPage, customLimit) => {
    console.log(currentPage, customLimit);
  };
  return (
    <div
      style={{
        margin: "25px 0",
        display: isLoading || totalItems < 10 ? "none" : "block",
      }}
    >
      <Pagination
        align="center"
        hideOnSinglePage={true}
        pageSize={limit}
        showSizeChanger={showSizeChanger}
        onShowSizeChange={onShowSizeChange}
        defaultCurrent={1}
        total={totalItems}
        current={currentPage}
        onChange={(e) => changePage(e)}
      />
    </div>
  );
};
